export default {"src":"/_next/static/media/bangladesh.99b677aa.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};